import { api } from 'data/api/api'

import {
  GetBusinessAccountRepresentativeDetailsResp,
  UpdateBusinessAccountRepresentativeDetailsArgs,
} from '../types/business-account-representative'

export const getBusinessAccountRepresentativeDetails = () =>
  api.get<GetBusinessAccountRepresentativeDetailsResp>('/business_accounts_dsa/representatives')

export const updateBusinessAccountRepresentativeDetails = ({
  identityDocumentExpirationDate,
  email,
}: UpdateBusinessAccountRepresentativeDetailsArgs) =>
  api.put('/business_accounts_dsa/representatives', {
    identity_document_expiration_date: identityDocumentExpirationDate,
    email,
  })
